import { createRouter, createWebHistory } from 'vue-router';
import InstallationSuccess from './components/InstallationSuccess.vue';
import Settings from './components/Settings.vue';
import NewebPayCheckout from './components/NewebPayCheckout.vue';
import NewebPayReturn from './components/NewebPayReturn.vue';
import NewebPayCustomerReturn from './components/NewebPayCustomerReturn.vue';
import AddPaymentMethod from './components/AddPaymentMethod.vue'; // T034
import PaymentMethodReturn from './components/PaymentMethodReturn.vue'; // T034

const routes = [
  {
    path: '/',
    name: 'Home',
    // App.vue 會處理根路由的顯示邏輯
    component: { template: '<div></div>' },
  },
  {
    path: '/installation-success',
    name: 'InstallationSuccess',
    component: InstallationSuccess,
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
  },
  {
    path: '/custom-provider',
    name: 'CustomProvider',
    component: Settings, // 使用相同的 Settings 組件
  },
  {
    path: '/checkout',
    name: 'NewebPayCheckout',
    component: NewebPayCheckout,
    meta: { isBare: true },
  },
  {
    path: '/newebpay/checkout',
    name: 'NewebPayCheckoutDirect',
    component: NewebPayCheckout,
    meta: { isBare: true },
  },
  {
    path: '/payment-return',
    name: 'NewebPayReturn',
    component: NewebPayReturn,
  },
  {
    path: '/newebpay/return',
    name: 'NewebPayReturnDirect',
    component: NewebPayReturn,
    meta: { isBare: true },
  },
  {
    path: '/customer-return',
    name: 'NewebPayCustomerReturn',
    component: NewebPayCustomerReturn,
    meta: { isBare: true },
  },
  {
    path: '/subscription/return',
    name: 'SubscriptionReturn',
    component: NewebPayReturn,
    meta: { isBare: true },
  },
  // 一些第三方（例如金流平台）可能直接 POST 後回傳 HTML，URL 停留在 /api/subscription/return
  // 為了讓 SPA 在這個 path 下也正確載入回傳頁面，而不是回到根路由顯示安裝畫面，加入對應路由
  {
    path: '/api/subscription/return',
    name: 'SubscriptionReturnApiCompat',
    component: NewebPayReturn,
    meta: { isBare: true },
  },
  // T034 - 約定信用卡授權路由
  {
    path: '/add-payment-method',
    name: 'AddPaymentMethod',
    component: AddPaymentMethod,
    meta: { isBare: true },
  },
  {
    path: '/payment-method-return',
    name: 'PaymentMethodReturn',
    component: PaymentMethodReturn,
    meta: { isBare: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;